import React, { useState, useEffect } from 'react';

import AgencyEntity from '../../Components/AgencyEntity'
import { normalizeKeys } from '../../utils';

export default function AgencyEntityDetails(props) {

    const [ agency, setAgency ] = useState({
        codigo_orgao: "",
        nome_orgao: "",
        nome_rede_atendimento: "",
        abrangencia: "",
        uf: "",
        nome_municipio: "",
        horarios: [
            {
                dias_semana: "",
                hora_inicio: "",
                hora_fim: ""
            }
        ],
        atendimento_presencial: false,
        data_credenciamento: "",        
        referencia_autorizacao: "",
        orgaos_autorizados: "",
        realiza_atendimento: false 
    });
    const [ modalError, setModalError ] = useState(false);
    const [ messageError, setMessageError ] = useState("");

    useEffect(()=>{  
        if ((props.location.state?.result_search !== undefined)) {  //Carrega as informações de cadastro da unidade antes do clique no botão "Cadastrar Gestor Regional"
            const agencyLowercase = normalizeKeys(props.location.state.result_search);
            setAgency(agencyLowercase);  
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

     // ================================================================================

    return (
        <>
            <AgencyEntity
                pageTitle='Detalhamento da rede de atendimento' //OK
                agency={agency} //OK 
                modalError ={modalError} //OK
                setModalError={setModalError} //OK
                setMessageError={setMessageError} //OK
                messageError={messageError} //OK
                buttonCancelRoute='/gerenciarOrgao' //OK
                history={props.history} //OK
            />
        </>
    );
}